module.exports = __webpack_public_path__ + "b77fc32c1a70e29d0b5563e65497c9ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/vibo_vibo-magenta-transparent.png
// module id = 114
// module chunks = 16